import * as React from 'react';
import { Doughnut } from 'react-chartjs-2';
import {
  EventConfigProps,
  EventConfigTypes,
  WidgetProps,
  ComponentProps,
} from '@intermix-dashboard/core';
import { colors } from '../../transforms';
import { useThemeObserver } from '../hooks/useThemeObserver';
export const IntermixDonutChartComponent: React.FC<ComponentProps> = ({
  data,
  options,
  dataTransform,
  eventConfig,
}) => {
  const inputRef = React.useRef(null);
  const [renderData, setRenderData] = React.useState<any>(null);
  const { display } = useThemeObserver();
  React.useEffect(() => {
    if (dataTransform) {
      setRenderData(dataTransform(data, options));
    } else {
      setRenderData(data);
    }
  }, [data, options.title, dataTransform]);

  return (
    <div
      ref={inputRef}
      style={{ display: 'flex', width: '100%', flex: '1' }}
      id="intermix-card"
    >
      <>
        {renderData && display && (
          <Doughnut
            data={JSON.parse(JSON.stringify(renderData))}
            onElementsClick={(elems) => {
              const defaultEventConfig = eventConfig?.find(
                (item: EventConfigProps) =>
                  item.type === EventConfigTypes.DEFAULT
              );
              if (
                defaultEventConfig &&
                elems &&
                elems.length > 0 &&
                typeof elems[0]._index !== 'undefined'
              ) {
                const event = new CustomEvent('intermix-event', {
                  detail: {
                    key: defaultEventConfig.key,
                    value: elems[0]._model.label,
                  },
                  bubbles: true,
                  cancelable: false,
                  composed: true, // makes the event jump shadow DOM boundary); */
                });
                (inputRef.current as any).dispatchEvent(event);
              }
            }}
          />
        )}
      </>
    </div>
  );
};

export const IntermixDonutChartWidget: WidgetProps = {
  id: 'dn-chart',
  component: IntermixDonutChartComponent,
  options: {
    w: 4,
    h: 4,
    colors: colors,
  },
};
